import { jsx as f } from "react/jsx-runtime";
import { memo as i } from "react";
import { InputNumber as p, Input as c } from "antd";
const l = i(({
  value: u,
  onChange: r,
  type: m
}) => m === "numeric" ? /* @__PURE__ */ f(
  p,
  {
    value: u,
    type: m,
    onChange: (t) => {
      t && (r == null || r(t));
    }
  }
) : /* @__PURE__ */ f(
  c,
  {
    value: u,
    type: m,
    onChange: (t) => r == null ? void 0 : r(t.target.value)
  }
));
export {
  l as default
};
//# sourceMappingURL=InputSelector.js.map
